import { css } from '@compiled/react';

import { Pagination } from '../../../../libraries/design/components/pagination/src/pagination';

export type UniformPaginationProps = {
	/** Total number of pages to display */
	pages: number;
};

const centerStyles = css({
	display: 'flex',
	justifyContent: 'center',
	width: '100%',
});

const UniformPagination = (props: UniformPaginationProps) => {
	// Generate pages array from total pages
	const pagesArray = Array.from({ length: props.pages }, (_, i) => i + 1);

	// For now, using defaults until page logic is implemented
	const selectedIndex = 0;

	return (
		<div css={centerStyles}>
			<Pagination pages={pagesArray} selectedIndex={selectedIndex} />
		</div>
	);
};

export default UniformPagination;
